export interface IQuery { }

export class IndividualReportQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.Regions.Queries.IndividualReportQueryV1, TCh.Domain.RankHR'

	PersonId: string
	VotingCycle: string

	constructor (personId: string, votingCycle: string)
	{
		this.PersonId = personId
		this.VotingCycle = votingCycle
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.Regions.Queries.IndividualReportQueryV1, TCh.Domain.RankHR'
	}

}

export class OverallReportQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.Regions.Queries.OverallReportQueryV1, TCh.Domain.RankHR'

	RegionId: string

	constructor (regionId: string)
	{
		this.RegionId = regionId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.Regions.Queries.OverallReportQueryV1, TCh.Domain.RankHR'
	}

}

export class RegionQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.Regions.Queries.RegionQueryV1, TCh.Domain.RankHR'

	RegionId: string

	constructor (regionId: string)
	{
		this.RegionId = regionId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.Regions.Queries.RegionQueryV1, TCh.Domain.RankHR'
	}

}

export class SurveyByPersonQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.Regions.Queries.SurveyByPersonQueryV1, TCh.Domain.RankHR'

	PersonId: string

	constructor (personId: string)
	{
		this.PersonId = personId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.Regions.Queries.SurveyByPersonQueryV1, TCh.Domain.RankHR'
	}

}

export class VotingProgressQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.Regions.Queries.VotingProgressQueryV1, TCh.Domain.RankHR'

	RegionId: string

	constructor (regionId: string)
	{
		this.RegionId = regionId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.Regions.Queries.VotingProgressQueryV1, TCh.Domain.RankHR'
	}

}

